module.exports = __webpack_public_path__ + "img/芯片.1faa6a92.svg";